(function (){
    'use strict';
    angular.module('app')
    .controller('ReportApprovalController', ReportApprovalController)

    ReportApprovalController.$inject=[
        '$scope',
        'ApprovedReportTableService',
        'RejectReportApprovalTableService',
        'PendingReportApprovalTableService',
        '$window',
        '$routeParams',
        '$location'
    ]
   
    
    function ReportApprovalController(
        $scope,
        ApprovedReportTableService,
        RejectReportApprovalTableService,
        PendingReportApprovalTableService,
        $window,
        $routeParams,
        $location

    ){
        const vm = this;
        vm.pendingReport = new PendingReportApprovalTableService
       
        // vm.tableData = new ApprovedReportTableService({}).tableData;
        // vm.rejectedReportTable = new RejectReportApprovalTableService({}).tableData;

        $scope.goBack = function(){
            $window.history.back();
        }

       
        $scope.changeTab = function(tab){
           
           if(vm.activeTab !==tab){
                vm.activeTab = tab;
                activeTabIndex(tab)
           }
           
        }

        function activeTabIndex(tab){
            if(tab === 0){
                vm.pendingReportTable = new PendingReportApprovalTableService().tableData;
                vm.rejectedReportTable = false;
                vm.tableData = false;
            }

            if(tab === 1){
                vm.rejectedReportTable = new RejectReportApprovalTableService().tableData;
                vm.pendingReportTable = false;
                vm.tableData = false;
            }

            if(tab === 2){
                vm.tableData = new ApprovedReportTableService().tableData;
                vm.pendingReportTable = false;
                vm.rejectedReportTable = false
            }
        }

        init();

        function init(){
            $scope.changeTab(0)
        }
    };
})()


// WEBPACK FOOTER //
// ./js/controllers/affiliate-sale/ReportApprovalController.js